require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/fn/symbol/iterator.js
// module id = 237
// module chunks = 2